module.exports = __webpack_public_path__ + "2066c6550d293ffedb262a6cb391710e.pdf";